{
  "intro": "A firewall filters traffic to and from your servers before it reaches them. A server without a firewall accepts everything. Once a firewall is applied, only what its rules allow gets through; everything else is dropped. Firewalls are free.",
  "create": "Create firewall",
  "empty": "No firewalls yet",
  "emptyLead": "Without a firewall every port a server opens is reachable from the internet. Create one that allows only what you need, such as SSH and your web ports, and apply it to your servers.",
  "name": "Name",
  "nameHint": "What it protects, e.g. web-public.",
  "rules": "Rules",
  "rulesCount": "{{inbound}} in, {{outbound}} out",
  "appliedTo": "Applied to",
  "appliedNothing": "Nothing",
  "appliedCount": "{{servers}} servers, {{selectors}} selectors",
  "createdOn": "Created",
  "open": "Open",
  "delete": "Delete",
  "inUseReason": "Applied to resources; remove it from all of them first.",
  "back": "All firewalls",
  "notFound": "This firewall no longer exists.",
  "newTitle": "New firewall",
  "newIntro": "Write the rules, then choose where the firewall applies. Rules only allow: anything they do not match is dropped once the firewall is applied.",
  "stepName": "Name",
  "stepInbound": "Inbound rules",
  "stepInboundLead": "Traffic arriving at the server. SSH and ping from anywhere are filled in; change or remove them as you need.",
  "stepOutbound": "Outbound rules",
  "stepOutboundLead": "Traffic leaving the server. Without outbound rules all outgoing traffic is allowed; add a rule and only what the rules allow can leave.",
  "stepApply": "Apply to",
  "stepApplyLead": "Pick servers, or apply by label selector: servers with matching labels get the firewall, also ones created later.",
  "stepLabels": "Labels",
  "summary": "Summary",
  "summaryInbound": "Inbound rules",
  "summaryOutbound": "Outbound rules",
  "summaryOutboundAll": "all traffic allowed",
  "summaryServers": "Servers",
  "summarySelectors": "Label selectors",
  "summaryNotApplied": "Not applied yet: it has no effect until you apply it.",
  "submit": "Create firewall",
  "created": "Firewall “{{name}}” created",
  "fixErrors": "Some rules are not complete. Check the highlighted fields.",
  "direction": {
    "in": "Inbound",
    "out": "Outbound"
  },
  "protocol": "Protocol",
  "port": "Port or range",
  "portHint": "22 or 8000-8100",
  "portNone": "No ports",
  "portInvalid": "Give a port (22) or a range (8000-8100), 1–65535.",
  "sources": "Allowed sources",
  "destinations": "Allowed destinations",
  "ipsHint": "Addresses with a prefix, separated by commas: 203.0.113.0/24, 2001:db8::/32",
  "ipsInvalid": "Write addresses with a prefix, e.g. 203.0.113.7/32, separated by commas.",
  "ipsRequired": "Name at least one address range, or choose “anywhere”.",
  "anyIpv4": "Any IPv4",
  "anyIpv6": "Any IPv6",
  "description": "Description",
  "descriptionHint": "Optional, e.g. what the port is for.",
  "addRule": "Add rule",
  "removeRule": "Remove rule",
  "noInbound": "No inbound rules: once applied, the firewall lets nothing in.",
  "noOutbound": "No outbound rules: all outgoing traffic is allowed.",
  "servers": "Servers",
  "noServersInProject": "The project has no servers yet. Apply the firewall later, or by label selector.",
  "labelSelectors": "Label selectors",
  "labelSelectorsHint": "One per line, e.g. role=web or env in (prod,staging).",
  "tabs": {
    "rules": "Rules",
    "resources": "Resources",
    "settings": "Settings",
    "delete": "Delete"
  },
  "rulesIntro": "Rules only allow traffic; once the firewall is applied, whatever no rule matches is dropped. Saving replaces the whole rule set at once.",
  "unsaved": "You have unsaved changes to the rules.",
  "save": "Save rules",
  "discard": "Discard changes",
  "saving": "Saving rules",
  "leaveTitle": "Leave without saving?",
  "leaveLead": "Your changes to the rules are lost if you leave this page now.",
  "leave": "Leave",
  "stay": "Stay",
  "resourcesIntro": "Where the firewall applies. A server with several firewalls gets the rules of all of them.",
  "applyServers": "Apply to servers",
  "applyServersLead": "The firewall starts filtering the chosen servers' traffic right away.",
  "applySelector": "Apply by label selector",
  "applySelectorLead": "Every server whose labels match gets the firewall, also servers created later.",
  "selector": "Label selector",
  "selectorHint": "For example role=web, env!=dev or tier in (a,b).",
  "selectorInvalid": "Write a label selector, e.g. role=web.",
  "noCandidates": "Every server of the project already has this firewall.",
  "apply": "Apply",
  "applying": "Applying the firewall",
  "target": "Applied to",
  "targetServer": "Server",
  "targetKind": "Kind",
  "targetSelector": "Label selector",
  "matches": "Matching servers",
  "matchesNone": "none right now",
  "notApplied": "Not applied to anything",
  "notAppliedLead": "The firewall has no effect until you apply it to servers or a label selector.",
  "remove": "Remove",
  "removeTitle": "Remove the firewall from {{name}}?",
  "removeConsequence": "Its rules stop filtering there: without another firewall the server accepts all traffic.",
  "removeSelectorConsequence": "Servers that got it only through this selector stop being filtered by it.",
  "removing": "Removing the firewall",
  "settingsIntro": "Name and labels of the firewall.",
  "saved": "Saved",
  "deleteIntro": "Deleting a firewall cannot be undone. Only a firewall that is applied to nothing can be deleted.",
  "deleteTitle": "Delete the firewall “{{name}}”?",
  "deleteRules": "Its rules are deleted with it.",
  "deleteNoEffect": "It is applied to nothing, so no server changes.",
  "deleteBlocked": "The firewall is still applied. Remove it from all resources first.",
  "removeAll": "Remove from all resources",
  "removeAllTitle": "Remove “{{name}}” from all resources?",
  "removeAllConsequence": "Servers it protects accept all traffic unless another firewall applies to them.",
  "deleted": "Firewall “{{name}}” deleted",
  "running": "Change in progress…",
  "anyPort": "Any port",
  "anyPortInbound": "All {{protocol}} ports are open (1–65535): every program on the server listening on {{protocol}} becomes reachable from these addresses, databases and admin panels included. If you need only a few ports, list them as separate rules.",
  "anyPortOutbound": "All {{protocol}} ports (1–65535) to these addresses are allowed."
}
